import React, { ReactNode, useEffect } from 'react';
import { api, apiStatic } from 'AurionCR/components';
import axios, { InternalAxiosRequestConfig } from 'axios';
import { prepareDateToSave } from './index';

const instances = [apiStatic, api, axios];

/**
 * Converts plain PATCH bodies to .NET-style [{ path, value }] ops.
 * Idempotent: if body is already an ops array (e.g. interceptor registered twice
 * under React Strict Mode), leave it unchanged — callers should keep passing
 * plain objects via asPatchBody(), same as the rest of the app.
 */
const patchDotNet5 = (conf: InternalAxiosRequestConfig) => {
  if (
    conf.method === 'patch' &&
    conf.data &&
    typeof conf.data === 'object' &&
    !Array.isArray(conf.data)
  ) {
    conf.data = Object.entries(prepareDateToSave(conf.data))
      .filter(([, value]) => value !== undefined)
      .map(([path, value]) => {
        return { path, value };
      });
  }
  return conf;
};

interface IAxiosInterceptorPatch {
  children: ReactNode;
}

export const AxiosInterceptorPatch: React.FC<IAxiosInterceptorPatch> = ({ children }) => {
  useEffect(() => {
    const interceptorIds = instances.map((instance) =>
      instance.interceptors.request.use(patchDotNet5),
    );

    return () => {
      instances.forEach((instance, index) => {
        instance.interceptors.request.eject(interceptorIds[index]);
      });
    };
  }, []);

  return <>{children}</>;
};
